module.exports = __webpack_public_path__ + "static/media/Omari Brandt.5fbf5d8f.png";